import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { computed, inject, onMounted } from 'vue';
import type { Ref } from 'vue';

interface CampaignStageItem {
    id: string;
    kicker: string;
    title: string;
    link: string;
    text?: string;
    backgroundMedia?: string;
    backgroundMediaAlt?: string;
    image?: string;
    imageAlt?: string;
    linkLabel?: string;
    linkDescription?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignStageItem',
  props: {
    id: null,
    kicker: null,
    title: null,
    link: null,
    text: null,
    backgroundMedia: null,
    backgroundMediaAlt: null,
    image: null,
    imageAlt: null,
    linkLabel: null,
    linkDescription: null
  },
  setup(__props: any) {

const props = __props as {
    id: string;
    kicker: string;
    title: string;
    link: string;
    text?: string;
    backgroundMedia?: string;
    backgroundMediaAlt?: string;
    image?: string;
    imageAlt?: string;
    linkLabel?: string;
    linkDescription?: string;
}


const activeStage = inject<Ref<string>>('activeStage');
const activeStageIndex = inject<Ref<number>>('activeStageIndex');
const autoplayOn = inject<Ref<boolean>>('autoplayOn');
const register = inject<(item: { id: string; kicker: string }) => void>(
    'registerCampaignStageItem',
    () => undefined
);
const onClick = inject<(id: string) => void>('clickCampaignStageItem', () => undefined);
const isActive = computed(() => activeStage.value === props.id);

onMounted(() => {
    register(props);
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    active: _unref(isActive),
    index: _unref(activeStageIndex) + 1,
    clicked: _unref(onClick),
    autoplayOn: _unref(autoplayOn)
  })
}
}

})